module.exports = __webpack_public_path__ + "static/media/star-active.7b6ae705.svg";